import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { AbstractPane } from '@app/library/panes/models/abstract-pane';

import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
  selector: 'app-webinar-widget',
  templateUrl: './webinar-widget.component.html',
  styleUrls: ['./webinar-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, LazyLoadImageModule, RouterModule],
})
export class WebinarWidgetComponent extends AbstractPane {
  hasContent(): boolean {
    return !!this._pane;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }
}
